import {SurveyFormModel} from "../model/SurveyFormModel";
import {SurveyFormListOptions} from "../model/SurveyFormListOptions";
import {BaseDataProvider} from "./BaseDataProvider";

export class SurveyFormDataProvider
    extends BaseDataProvider<SurveyFormModel, SurveyFormListOptions> {
    constructor() {
        super(`/survey/forms`);
    }
    getInsertData = (data: SurveyFormModel): any => {
        const req = {...data};
        delete req.id;
        delete req.created;
        return req;
    }


    getUpdateData = (id: string, data: SurveyFormModel): any => {
        const req = {...data};
        delete req.id;
        delete req.created;
        return req;
    }
}